import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=d2e9a306"
import script from "./selectPerson.vue?vue&type=script&lang=js"
export * from "./selectPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2e9a306')) {
      api.createRecord('d2e9a306', component.options)
    } else {
      api.reload('d2e9a306', component.options)
    }
    module.hot.accept("./selectPerson.vue?vue&type=template&id=d2e9a306", function () {
      api.rerender('d2e9a306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/formOverlay/selectPerson.vue"
export default component.exports